// src/components/layout/Footer.jsx
import { motion } from 'framer-motion';
import { Facebook, Instagram, Youtube, ArrowRight } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-brand-navy text-gray-300 pt-16 pb-8">
      <div className="max-w-8xl mx-auto px-6 lg:px-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Column 1 - Contact Us */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="text-gray-400">123 Nii Amarkai St, Obranikwa, Accra, Ghana</li>
              <li className="text-gray-400">(123) 456-7890</li>
              <li className="text-gray-400">WhatsApp: (987) 654-3210</li>
              <li className="text-gray-400">info@site.com</li>
            </ul>
          </div>

          {/* Column 2 - Our Company */}
          {/* <div>
            <h4 className="text-white font-semibold mb-6">Our Company</h4>
            <ul className="space-y-3">
              {['All Properties', 'Property for Buy', 'Property for Rent', 'Our Agents'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-400 hover:text-brand-orange transition">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Column 3 - Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['About Us', 'Contact Us', 'Latest News', 'FAQ'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-400 hover:text-brand-orange transition">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Newsletter */}
          <div>
            <h4 className="text-white font-semibold mb-6">Join Our Newsletter</h4>
            <p className="text-gray-400 mb-4">Sign up for updates on our latest news</p>
            <div className="relative">
              <input
                type="email"
                placeholder="Enter your e-mail"
                className="w-full bg-gray-800 border border-gray-700 rounded-full px-4 py-3 pr-12 focus:outline-none focus:border-brand-orange transition"
              />
              <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-brand-orange rounded-full p-2 hover:bg-brand-orange-hover transition">
                <ArrowRight className="w-5 h-5 text-white" />
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-4">
              By submitting, you agree to our Terms of Service and Privacy Policy
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            Copyright © {new Date().getFullYear()} – Prized by Machinee. All rights reserved.
          </p>
          <div className="flex gap-6">
            {[Facebook, Instagram, Youtube].map((Icon, index) => (
              <motion.a
                key={index}
                href="#"
                whileHover={{ scale: 1.1 }}
                className="text-gray-400 hover:text-white transition"
              >
                <Icon className="w-5 h-5" />
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;